module.exports = __webpack_public_path__ + "media/src/ui/images/tmDeviceDesktop-85ca95632f4b6999808d2fa38f878f16.svg";